import { Dispatch, memo, SetStateAction } from 'react'
import { ISVGSettings } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import SVGChartSettingsContent from '@/pages/Dashboards/Charts/SVGChart/SvgChartSettingsSidePage/SVGChartSettingsContent'

interface IProps {
  step: 'common-info' | 'settings'
  setSettings: Dispatch<SetStateAction<ISVGSettings>>
}

const CreateSvgChartSidePageContent = (props: IProps) => {
  return (
    <div className="flex-lines gap16 height100" style={{ minHeight: 0 }}>
      <h5 className="text-heading-5">Создание виджета: SVG диаграмма</h5>
      <SeparateLine />
      <SVGChartSettingsContent {...props} />
    </div>
  )
}

export default memo(CreateSvgChartSidePageContent)
